import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaOrdenesCompraVendedor = ({desde, hasta, styles}) => {
    const tarjeta = "ordenesCompra";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    const getData = async (desde, hasta) => {
        setLoading(true);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&desde=${desde}&hasta=${hasta}&vendedor=1`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(desde, hasta);
    }, [desde, hasta]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data?.total)}
                    </div>
                    <div style={styles.subtitulo}>
                        Órdenes de Compra
                    </div>
                </div>

                <div className="row">
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countClientes}</small> {formatCurrency(data?.totalClientes)}</strong>
                        </div>
                        <small style={styles.label}>Clientes</small>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TarjetaOrdenesCompraVendedor;
